"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTemplateResponseDto = void 0;
const mappable_base_1 = require("../../mappable.base");
const class_transformer_1 = require("class-transformer");
const notification_template_create_dto_1 = require("./notification-template-create.dto");
class NotificationTemplateResponseDto extends mappable_base_1.MappableBase {
    id;
    name;
    description;
    isGlobal;
    isSchoolGroupLevel;
    schoolGroupId;
    schoolGroup_name;
    schoolId;
    school_name;
    subject;
    body;
    bodyType;
    notificationType;
    templateIdentifier;
    created;
    constructor(notificationTemplateResponseOptions) {
        super();
        if (notificationTemplateResponseOptions)
            Object.assign(this, notificationTemplateResponseOptions);
    }
    getFields() {
        return [
            'id',
            'name',
            'description',
            'schoolId',
            'schoolGroupId',
            'isGlobal',
            'isSchoolGroupLevel',
            'school_name',
            'schoolGroup_name',
            'subject',
            'body',
            'bodyType',
            'notificationType',
            'templateIdentifier',
            'created'
        ];
    }
    mapFields(source, skipNested = false, skipTransforms = false) {
        return super.mapFields(source, skipNested, skipTransforms);
    }
}
exports.NotificationTemplateResponseDto = NotificationTemplateResponseDto;
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], NotificationTemplateResponseDto.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "description", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], NotificationTemplateResponseDto.prototype, "isGlobal", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], NotificationTemplateResponseDto.prototype, "isSchoolGroupLevel", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], NotificationTemplateResponseDto.prototype, "schoolGroupId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "schoolGroup_name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], NotificationTemplateResponseDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "school_name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "subject", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "body", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "bodyType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "notificationType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], NotificationTemplateResponseDto.prototype, "templateIdentifier", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], NotificationTemplateResponseDto.prototype, "created", void 0);
